

import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Building2, Users, ThumbsUp, EllipsisVertical, CircleX } from 'lucide-react';
import { Badge, Tooltip } from 'antd';
import { useTeam } from "../../providers/TeamProvider";
import { useAuth } from '../../providers/AuthProvider';
import User from '../../models/User';
import { UserImageCircleNEW } from '../../components/UserImageCircle';
import TalentDisplayName from '../../components/TalentDisplayName';
import CircleProgress from '../../components/CircleProgress';
import HideTalentPricingTooltip from '../clients/HideTalentPricingTooltip';
import TeamMatchDetails from './TeamMatchDetails';


const TeamTileRedesign = ({ children, ...props }) => {
    const { auth } = useAuth();
    const { team, matchingDisciplines, criteria } = useTeam();
    const location = useLocation();


    const isBrowsePage = location.pathname?.includes('browse');
    const isShortlistPage = location.pathname?.includes('bidding') && location.pathname?.includes('shortlist') || (location.pathname?.includes('active') && location.pathname?.includes('short-list'));
    const isTalentPoolPage = location.pathname?.includes('bidding') && location.pathname?.includes('talent-pool');

    const isAgency = team.type === 'Agency' && team.supplier_client;

    return (
        <article
            className={TB.mapClass("team-tile-redesign bg-white border shadow-sm flex flex-col transition-all flex1 h-full rounded-2xl overflow-hidden group", {
                // 'border-primary border-1': isHighlighted,
                // 'border-red-500 border-1': candidate.declinedPosition(),
            })}
        >
            <HeaderRow talent={team} />

            <ActionRow
                isDisabled={props.isDisabled}
                shortlistView={props.shortlistView}
                isShortlistPage={isShortlistPage}
            // onCandidateAction={onCandidateAction}
            />

            <div className="flex flex-col h-full gap-2 items-center text-center px-[22px] pb-3">
                <h3 className="m-0 text-xl font-bold tracking-tight leading-tight overflow-hidden text-ellipsis whitespace-nowrap">
                    {team.name}
                </h3>
                <div className="flex flex-col flex-1 justify-center items-center">
                    {isAgency && (
                        <div className="flex items-center gap-1.5 text-[12.5px] text-gray-500">
                            <img src={team.supplier_client.logo_path} className="h-[22px] rounded" />
                            From
                            <Link to={`/agency-profiles/${team.supplier_client.id}`} className="flex items-center gap-2">
                                <span className="font-bold text-gray-900 hover:text-primary hover:underline">
                                    {team.supplier_client.name}
                                </span>
                            </Link>
                        </div>
                    )}
                    {team.location && team.location?.city && team.location?.state && (
                        <span className="flex gap-1.5 items-center">
                            <i className="fa fa-map-marker-alt text-[10px] text-gray-400" />
                            <p className="text-[10px]">{team.location.city}{!!team.location.state && `, ${team.location.state}`}</p>
                        </span>
                    )}
                </div>

                <div className="text-center px-5 pb2.5">
                    <p className="text-xs line-clamp-2 font-light">{team.fullBio() || ''}</p>
                    <Link
                        target="_blank"
                        to={{
                            ...location,
                            pathname: `team-profiles/${team.id}`,
                            state: {
                                linkParams: {
                                    title: 'Back',
                                    path: location.pathname + (location.search || '')
                                }
                            }
                        }}
                        className="btnbtn-link text-[11px] inline-block py-2 text-primary hover:text-primary-lightest no-underline hover:underline"
                    >
                        View Team Profile →
                    </Link>
                </div>
            </div>

            <TeamMembers />

            <RoleMatch />

            <div className="bg-wrippleLightLight pt-3 px-5 pb-4 flex1 flex flex-col items-center gap-2">
                <RateRow />
                {/* <CTARow {...props} isShortlistPage={isShortlistPage} isTalentPoolPage={isTalentPoolPage} isBrowsePage={isBrowsePage} /> */}
            </div>

            {children}
        </article>
    )
}

export default TeamTileRedesign;

const HeaderRow = ({ talent }) => {
    // const { showCandidateProposal } = useCandidate();

    return <div className="pt-2" />

    // const isDeclined = talent.declinedPosition();
    // const isShortlisted = talent.shortlistedAccepted();
    // const hasProposal = talent.hasProposalForClient();
    // const isHighlighted = isShortlisted || hasProposal;

    // return (
    //     <div className={TB.mapClass("min-h-[34px] flex relative items-center justify-between px-3 border-b", {
    //         'bg-primary text-white': isHighlighted,
    //         'bg-[#F4F5F9]': !isHighlighted && !isDeclined,
    //         'bg-red-500': isDeclined,
    //     })}>
    //         {isHighlighted && (
    //             <>
    //                 <span className="text-xs">
    //                     {isShortlisted ? 'Shortlisted' : 'Proposal Submitted'}
    //                 </span>

    //                 {/* <button
    //                     type="button"
    //                     className="text-xxs text-white cursor-pointer hover:opacity80 transition flex items-center gap-1 py-0.5 pl-2.5 pr-2 bg-primary-lighter hover:bg-primary-lightest rounded-full"
    //                     onClick={() => showCandidateProposal()}
    //                 >
    //                     View Proposal <ChevronRight className="text-inherit h-3 w-3 inline" />
    //                 </button> */}
    //             </>
    //         )}

    //         {isDeclined && (
    //             <span className="text-xs text-white text-center w-full">Not Interested</span>
    //         )}
    //     </div>
    // );
}


const ActionRow = ({ onTeamAction, shortlistView, isShortlistPage, isDisabled }) => {
    const { auth } = useAuth();

    const {
        team,
        canFavorite,
        removeFromFavorites,
        addToFavorites,
    } = useTeam();

    const isAgency = team.type === 'Agency' && team.supplier_client;

    return (
        <div className="flex relative justify-between px-2.5 py-2 min-h-[34px]">
            <div className="flex gap-1.5 flex-1 justify-start items-center">
                {/* {!isShortlistPage && (
                    <IconButton
                        className={`${!!bulkActions?.length && 'invisible'}`}
                        disabled={isDisabled || !!bulkActions?.length}
                        onClick={async () => {
                            const confirm = await TB.alert("warning", "Archive Candidate",
                                "Are you sure you want to remove this candidate for this project?",
                                [{ title: 'Yes, Continue' }, { title: 'Cancel' }]
                            );

                            if (confirm) {
                                return onCandidateAction(candidate.wasDisliked() ? removeFromArchive : addToArchive)
                            }
                        }}
                    >
                        <CircleX className={`h-3.5 w-3.5 ${candidate.wasDisliked() ? 'rotate-45' : ''}`} />
                    </IconButton>
                )} */}
            </div>

            <p className="text-xxs uppercase self-center pt-0.5 pb-px tracking-wider px-2.5 rounded-full border border-gray-200 text-gray-400">
                {isAgency ? 'Agency Team' : 'Freelance Collective'}
            </p>


            <div className={`flex gap-1.5 flex-1 justify-end items-center`}>
                {!shortlistView && canFavorite && (
                    // <Badge count={otherUserLikes?.length ? userLikes.length : 0} size="small">
                    <Tooltip
                        title={team.is_favorite ? 'Remove Favorite' : 'Add Favorite'}
                    >
                        <IconButton
                            disabled={isDisabled}
                            onClick={() => onTeamAction(team.is_favorite ? removeFromFavorites : addToFavorites)}
                            className={team.is_favorite && '!bg-green-100 !border-green-400'}
                        >
                            <ThumbsUp className={`h-3.5 w-3.5 ${team.is_favorite ? 'text-green-500' : ''}`} />
                        </IconButton>
                    </Tooltip>
                    // </Badge>
                )}
            </div>
        </div>
    )
}

const IconButton = ({ className, children, ...props }) => {
    return (
        <button
            className={`h-[30px] w-[30px] rounded-lg flex items-center disabled:pointer-events-none disabled:opacity-80 justify-center border transition hover:-translate-y-[1px] ${className}`}
            {...props}
        >
            {children}
        </button>
    )
}

const TeamMembers = () => {
    const { team } = useTeam();
    const location = useLocation();

    const vips = TB.filter(team.topPositionsForDisplay(), vip => TB.isDefined(vip)).map(vip => User.make({ ...vip }));

    return (
        <div className="bg-wrippleLightLight py-2.5 px-3 flex">
            {vips.map((user, i) => (
                <Link
                    key={user.id}
                    className="flex flex-1 flex-col items-center"
                    to={{
                        ...location,
                        pathname: `${location.pathname}/team-profiles/${team.id}/talent-profiles/${user.id}`,
                        state: {
                            linkParams: {
                                title: 'Back',
                                path: location.pathname + (location.search || '')
                            }
                        }
                    }}
                >
                    <div className="h-[80px] w-[80px] rounded-full flex items-center justify-center transition-all duration-500 p-1 border hover:border-primary">
                        <UserImageCircleNEW
                            user={user}
                            className="!h-full !w-full img-grayscale"
                            showAvailabilityDot={false}
                            showOpenToWork={false}
                        />
                    </div>

                    <TalentDisplayName talent={user}>
                        <p className="text-xs mt-1.5">{user.firstNamePlusInitial()}</p>
                    </TalentDisplayName>

                    <p className="line-clamp-1 mx-2 text-xxs text-center">
                        {user.job_title}
                    </p>
                </Link>
            ))}

        </div>
    )
}


const SmallBadge = ({ children, className }) => {
    return (
        <p className={`inline-block py-px px-1.5 rounded text-xs border border-gray-300 bg-gray-200 ${className}`}>{children}</p>
    )
}

const FIT_STATUSES = [
    { minScore: 100, label: 'Perfect Match' },
    { minScore: 97, label: 'Exceptional Fit' },
    { minScore: 90, label: 'Excellent Fit' },
    { minScore: 84, label: 'Strong Fit' },
    { minScore: 75, label: 'Good Fit' },
    { minScore: 65, label: 'Moderate Fit' },
    { minScore: 50, label: 'Fair Fit' },
    { minScore: 35, label: 'Weak Fit' },
    { minScore: 15, label: 'Poor Fit' },
    { minScore: 0, label: 'Not a Fit' }
];


const RoleMatch = () => {
    const { team, criteria } = useTeam();

    if (!team?.hasMatching()) {
        return (
            <div>
                <p>Team Matching Not Available</p>
            </div>
        )
    }

    const showMatchDetails = () => {
        let matchCriteria = {};
        if (criteria) {
            matchCriteria = criteria;
        }

        return TB.event('Modal@show', {
            modalClass: 'match-details-modal',
            content: (
                <TeamMatchDetails
                    team={team}
                    isEngagementLead={false}
                    criteria={matchCriteria}
                />
            )
        })
    }


    return (
        <div className="flex flex-col items-center gap-2 pb-4 pt-6">
            <CircleProgress
                className="metric-circle self-center w-[8.5rem]"
                progress={team.overallMatchPercent()}
                strokeWidth={7}
            >
                <p>
                    <span className="text-xl">{team.overallMatchPercent(true)}%</span>
                    <small className="text-xs">Match</small>
                </p>
            </CircleProgress>

            <button
                type="button"
                // className="details-link"
                onClick={showMatchDetails}
                className="btnbtn-link text-[11px] inline-block py-2 text-primary hover:text-primary-lightest no-underline hover:underline"
            >
                View Match Details →
            </button>
        </div>
    )
    // return (
    //     <div className="flex flex-col items-center gap-2 py-4">
    //         <CircleProgress
    //             className="metric-circle w-20 self-center"
    //             progress={team.overallMatchPercent()}
    //             strokeWidth={13}
    //         >
    //             <span className="text-base font-bold">{team.overallMatchPercent(true)}</span>
    //         </CircleProgress>

    //         <p className="font-bold text-base">{FIT_STATUSES.find(status => team.overallMatchPercent(true) >= status.minScore)?.label}</p>
    //         <div className="flex items-center gap-2">
    //             <p className="text-xs font-light">Profile Skills & Experience</p>
    //             <SmallBadge>94</SmallBadge>
    //         </div>
    //         <div className="flex items-center gap-2">
    //             <p className="text-xs font-light">AI Resume Score</p>
    //             <SmallBadge>87</SmallBadge>
    //         </div>
    //     </div>
    // )
}

const RateRow = () => {
    const { team } = useTeam();
    const { auth } = useAuth();

    const label = "Average Standard Rate";

    return (
        <div className="flex flex-col items-center gap-2 w-full pt-2">
            <p className="text-xs uppercase font-bold text-wrippleAlternateDarker">{label}</p>

            {auth.canViewTalentPricing() ? (
                <div className="relative flex justify-center items-baseline flex-col">
                    <span className="text-2xl font-bold text-wrippleAlternateDarker">
                        {team.rangedPlatformRates()}
                        <span className="text-xs text-wrippleAlternateDarker">/hr</span>
                    </span>
                </div>
            ) : (
                <span className="text-lg font-bold"><HideTalentPricingTooltip /></span>
            )}
        </div>
    )
}


export const TeamTileRedesignSkeleton = () => {
    return (
        <article className="team-tile-redesign-skeleton bg-white border shadow-sm flex w-full flex-col transition-all flex1 h-full rounded-2xl overflow-hidden group">
            <div className="pt-2" />

            {/* ACTION ROW */}
            <div className="flex relative justify-between px-2.5 py-2 min-h-[34px]">
                <div className="flex-1" />
                <div className="skeleton rounded-full h-[21px] w-[161px]" />
                <div className="flex-1" />
            </div>


            {/* TEAM INFO */}
            <div className="flex flex-col h-full gap-2 items-center text-center px-[22px] pb-3">
                <div className="skeleton h-[25px] w-1/3" />

                <div className="w-full flex flex-col flex-1 gap-1 justify-center items-center">
                    <div className="skeleton h-3 w-3/5" />
                    <div className="skeleton h-3 w-3/5" />
                </div>

                <div className="py-3">
                    <div className="skeleton h-[10px] w-[115px]" />
                </div>
            </div>

            {/* TEAM MEMBERS */}
            <div className="bg-wrippleLightLight py-2.5 px-3 flex">
                {Array.from({ length: 3 }, () => (
                    <div className="flex flex-1 flex-col items-center justify-center">
                        <div className="skeleton h-[80px] w-[80px] rounded-full flex items-center justify-center" />

                        <div className="skeleton h-3 w-[55px] mt-1.5" />
                        <div className="skeleton h-2.5 w-[75px] mt-0.5" />
                    </div>
                ))}
            </div>

            {/* MATCH DETAILS */}
            <div className="flex flex-col items-center gap-2 pb-4 pt-6">
                <div className="skeleton h-[8.5rem] w-[8.5rem] rounded-full " />
                <div className="py-3">
                    <div className="skeleton h-[10px] w-[115px]" />
                </div>
            </div>


            {/* RATE ROW */}
            <div className="bg-wrippleLightLight pt-3 px-5 pb-4 flex1 flex flex-col items-center gap-2">
                <div className="flex flex-col items-center gap-2 w-full pt-2">
                    <div className="skeleton h-4 w-[168px]" />

                    <div className="skeleton h-7 w-[120px]" />
                </div>
            </div>
        </article>
    )
}
